import { APP_STORAGE_PREFIX } from "./appStorage";

const KEY = `${APP_STORAGE_PREFIX}push_prompt_dismissed_v1`;

function readMap() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function isPushPromptDismissed(dancerId) {
  if (!dancerId) return true;
  return Boolean(readMap()[dancerId]);
}

export function dismissPushPrompt(dancerId) {
  if (!dancerId) return;
  try {
    const map = readMap();
    map[dancerId] = Date.now();
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // ignore
  }
}
